import ComponentModule from 'lib/component-module';
import fetcher from 'lib/fetcher';
import store from 'lib/store';
import {
    template as hiwTemplate,
    tabLabel as hiwTabLabel,
    contentTemplate as hiwContentTemplate
} from 'lib/how-it-works';

ComponentModule.AddModule('.find-distributor', {
    prefix: 'find-distributor-',
    components: [
        fetcher({
            name: 'template',
            data(){
                return {
                    list: { template: '<div><slot></slot></div>' },
                    listVisible: false
                };
            },
            methods: {
                getDistributors() {
                    var self = this;

                    if (this.params.country) {
                        this.listVisible = true;

                        this.fetch(function(res) {
                            // const template = self.data;
                            const template = res.data;
                            // console.log("RES", res);
                            self.list = {
                                template,
                                components: {
                                    'hiw-template': {
                                        ...hiwTemplate,
                                        components: {
                                            'hiw-tab-label': hiwTabLabel,
                                            'hiw-content-template': hiwContentTemplate
                                        }
                                    }
                                }
                            };
    
                        }, {
                            params: {
                                ...this.params
                            }
                        }); 
                    } else {
                        this.listVisible = false;
                    }

                }
            }
        }, {
            fetchOnUpdateParams: false
        })
    ],
    store: store
});
